module.exports = __webpack_public_path__ + "img/icon_graph.89a2eceb.svg";